{
  "trust": {
    "awarded": "Verified by MatchPoint",
    "notReviewed": "Not yet reviewed",
    "notAssessed": "Not assessed"
  },
  "outcome": {
    "status": {
      "open": "Open",
      "won": "Won",
      "lost": "Lost"
    },
    "lostReason": {
      "price": "Price",
      "terms": "Commercial terms",
      "product_fit": "Product or specification fit",
      "compliance": "Regulatory or compliance",
      "logistics": "Logistics or delivery",
      "timing": "Timing or budget",
      "unresponsive": "A party stopped responding",
      "chose_other": "Chose another partner",
      "other": "Other"
    },
    "stage": {
      "matchAccepted": "Match accepted",
      "firstMeeting": "First meeting",
      "proposal": "Proposal / negotiation",
      "contractSigned": "Contract signed",
      "lost": "Lost"
    }
  },
  "consent": {
    "buyer": {
      "pending": "Waiting for supplier",
      "accepted": "Accepted",
      "declined": "Declined"
    },
    "supplier": {
      "pending": "Awaiting your response",
      "accepted": "Accepted",
      "declined": "Declined"
    },
    "moderator": {
      "pending": "Supplier: pending",
      "accepted": "Supplier: accepted",
      "declined": "Supplier: declined"
    },
    "chatBlocked": {
      "declined": "The supplier declined this match.",
      "pending": "Chat opens once the supplier accepts this match."
    }
  },
  "explanation": {
    "unavailable": "Explanation not available for this older match",
    "status": {
      "matched": "Matched",
      "partial": "Partial",
      "missing": "Missing",
      "not_assessed": "Not assessed"
    },
    "confidence": {
      "low": "Low confidence",
      "medium": "Medium confidence",
      "high": "High confidence"
    }
  },
  "leadSource": {
    "errors": {
      "typeRequired": "Please tell us how you heard about us.",
      "detailRequired": "Please specify where you heard about us.",
      "detailTooLong": "Please keep this under {{max}} characters."
    }
  },
  "intent": {
    "errors": {
      "corridorSide": "Please choose your side of the trade corridor.",
      "tradeRoles": "Please choose at least one role.",
      "companySize": "Please choose your company size.",
      "objective": "Please choose your main objective.",
      "marketEntryTimeline": "Please choose a timeline.",
      "objectiveDetails": "Please describe your objective.",
      "objectiveDetailsTooLong": "Please keep this under {{max}} characters."
    }
  },
  "region": {
    "north_america": "North America",
    "latin_america": "Latin America & Caribbean",
    "europe": "Europe",
    "middle_east": "Middle East",
    "africa": "Africa",
    "asia_pacific": "Asia-Pacific",
    "oceania": "Oceania",
    "other": "Other"
  },
  "upload": {
    "kinds": {
      "document": "PDF, DOC, DOCX, JPG or PNG",
      "image": "JPG or PNG",
      "pdf": "PDF"
    },
    "hint": "{{types}} (max. {{maxMb}} MB)",
    "empty": "The selected file is empty.",
    "tooLarge": "\"{{name}}\" is too large. Maximum size is {{maxMb}} MB.",
    "unsupportedType": "\"{{name}}\" is not a supported file type. Allowed types: {{types}}.",
    "invalidContent": "\"{{name}}\" does not look like a valid {{ext}} file. Allowed types: {{types}}."
  },
  "unit": {
    "unit": "Units (pieces)",
    "dozen": "Dozens",
    "thousandUnits": "Thousands of units",
    "kg": "Kilograms (kg)",
    "g": "Grams (g)",
    "t": "Tonnes (t)",
    "lb": "Pounds (lb)",
    "l": "Litres (l)",
    "ml": "Millilitres (ml)",
    "m3": "Cubic metres (m³)",
    "gal": "US gallons",
    "m": "Metres (m)",
    "km": "Kilometres (km)",
    "ft": "Feet (ft)",
    "m2": "Square metres (m²)",
    "ft2": "Square feet (ft²)",
    "container": "Containers",
    "pallet": "Pallets",
    "box": "Boxes / cartons",
    "bottle": "Bottles",
    "bag": "Bags / sacks"
  }
}
